'use client';

import classNames from 'classnames';
import { useTranslations } from 'next-intl';
import { useProjectFollowContext } from '@/app/[locale]/(entity)/components/provider/ProjectFollowProvider';
import { useProjectTabsContext } from '@/app/[locale]/(entity)/components/provider/ProjectTabsProvider';
import { TabsFilterValue } from '@/app/[locale]/(entity)/types/project/tabs';
import { Follow } from '@/app/components/Follow/Follow';
import { NewsBadge } from '~/components/Project/NewsBadge';

export const Tabs = () => {
  const t = useTranslations('PROJECT.TABS');

  const { badge, activeTabFilter, setTab } = useProjectTabsContext();
  const { isFollowedBtnDisplayed } = useProjectFollowContext();

  return (
    <>
      <div id="tabs" />
      <section className="project-tabs">
        <div className="centered-content project-tabs__content">
          <div className="project-tabs__tabs">
            {[
              TabsFilterValue.ONGOING,
              TabsFilterValue.STEPS,
              TabsFilterValue.NEWS,
            ].map(filter => (
              <button
                key={filter}
                type="button"
                className={classNames('project-tabs__tab', {
                  'project-tabs__tab--active': filter === activeTabFilter,
                })}
                onClick={() => {
                  setTab(filter);
                }}
              >
                {t(filter)}
                {!!badge[filter].count && (
                  <NewsBadge
                    hasMoreNews={badge[filter].hasMore}
                    newsCounter={badge[filter].count}
                  />
                )}
              </button>
            ))}
          </div>
          <div className="project-tabs__follow">
            {isFollowedBtnDisplayed && (
              <Follow />
            )}
          </div>
        </div>
      </section>
    </>
  );
};
